/* ============================================================
   säna — Sección FAQ
   Archivo: sana-faq.js
   → Subir a: Assets en Shopify Theme Editor
   ============================================================ */

(function () {
  'use strict';

  function initFaq() {
    document.querySelectorAll('.sana-faq-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = this.closest('.sana-faq-item');
        var isOpen = item.classList.contains('is-open');

        // cerrar todos
        document.querySelectorAll('.sana-faq-item').forEach(function (el) {
          el.classList.remove('is-open');
          el.querySelector('.sana-faq-trigger').setAttribute('aria-expanded', 'false');
        });

        // abrir el clickeado si estaba cerrado
        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaq);
  } else {
    initFaq();
  }
})();
